import 'rxjs'
import React, { Component } from 'react'
import { reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'
import Header from './Header'
import Slider from 'react-slick'
import _ from 'lodash'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import Snackbar from 'material-ui/Snackbar'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

class EditTownImages extends Component {
  constructor(props) {
    super(props)
    this.state = {
      previewImage: '',
      i: null,
      attachId: '',
      imageUrl: '',
      openFeaturedDilog: false,
      openRemoveDilog: false,
      imageId: '',
      openSnackbar: false,
      message: '',
      disableBtn: false,
      current_role: ''
    }
    this.onClickSave = this.onClickSave.bind(this)
    this.handleRequestClose = this.handleRequestClose.bind(this)
  }

  componentWillMount() {
    let _user = cookies.get('user')
    this.setState({ userid: _user.id, current_role: _user.role })
    const { getGeneratedReport, match: { params: { townId } } } = this.props
    getGeneratedReport(townId)
  }

  componentWillReceiveProps(np) {
    const { removeImg, history, featured, imageUpload, getGeneratedReport, match: { params: { townId } } } = np
    if (imageUpload || removeImg) {
      this.setState({
        message: imageUpload ? 'Images Uploaded Successfully' : 'Image has been removed successfully',
        openSnackbar: true,
        openRemoveDilog: false,
        disableBtn: false
      }, () => {
        getGeneratedReport(townId)
      })
    }
    if (featured) {
      this.setState({
        message: 'Image marked featured successfully',
        openSnackbar: true,
        openRemoveDilog: false,
        disableBtn: false
      }, () => {
        getGeneratedReport(townId)
      })
      // history.push('/town-report')
    }
  }

  componentWillUnmount() {
    this.props.clearTownPhase()
  }

  handleUserImage(e) {
    const { uploadImage, match: { params: { townId } } } = this.props
    const input = e.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (r) => {
        this.setState({
          previewImage: r.target.result,
          previewStatus: 'ViewPatientOnboarding_previewShowing'
        })
        const formdata = new FormData()
        formdata.append('image', input.files[0])
        formdata.append('townId', townId)
        uploadImage(formdata)
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  handleEmptyImage() {
    if (this.state.previewImage) {
      this.setState({ previewImage: '', previewStatus: '' })
    }
  }

  handleClose = () => {
    this.setState({ i: null, imageUrl: '', attachId: '', openFeaturedDilog: false, openRemoveDilog: false })
  }

  townImages(report) {
    return report && report.images.map((image, i) => {
      return(
        <div className="col-md-4 town-img-outer" key={i}>
          <div className={this.state.i === i ? 'town-image-select' : 'town-images'}>
            <img
              src={image.url}
              onClick={() => { !image.featured && this.setState({ i, imageUrl: image.url, attachId: image.attach_id, openFeaturedDilog: true }) }}
            />
          </div>
          {image.featured && <span className="featured_img">Featured</span>}
          {image.featured ? '' : <span className="remove_img" onClick={() => this.setState({ openRemoveDilog: true, imageId: image.id, attachId: image.attach_id, imageUrl: image.url })}>Remove</span>}
        </div>
      )
    })
  }

  handleRequestClose() {
    this.setState({ openSnackbar: false })
  }

  removeImage() {
    const { removeImage, match: { params: { townId } }, disableBtn } = this.props
    const { imageId, attachId, imageUrl } = this.state
    const data = {
      town_id: townId,
      url: imageUrl,
      image_id: imageId
    }
    removeImage(data)
  }

  onClickSave() {
    const { markFeatured, match: { params: { townId } }, history } = this.props
    const { imageUrl, attachId } = this.state
    this.setState({ openFeaturedDilog: false })
    const data = {
      town_id: townId,
      featured_image_url: imageUrl,
      image_id: attachId
    }
    this.setState({ disableBtn: true })
    imageUrl ? markFeatured(data) : history.push('/town-report')
  }

  render() {
    const { history, report, uploadProgress, disableBtn } = this.props
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }, {
        breakpoint: 520,
        settings: {
          slidesToShow: 1
        }
      }]
    }

    const actions = [
      <FlatButton label="Cancel" primary={true} onClick={this.handleClose} />,
      <FlatButton label="Yes" primary={true} keyboardFocused={true} onClick={ ()=> this.onClickSave()} />
    ]
    const actions2 = [
      <FlatButton label="Cancel" primary={true} onClick={this.handleClose} />,
      <FlatButton label="Yes" primary={true} keyboardFocused={true} onClick={() => this.removeImage()} />
    ]
    return (
      <section className="town-report">
        <Header title="Update Images"/>
        <div className="container">
          <div className="row town-table">
            <div className="col-md-6">
              <h3 className="update_images">Update Images</h3>
              <p className="update_para">Click on the image you want to featured.</p>
            </div>
            <div className="col-md-6">
              <br />
              <p>{_.get(report,'processed.town_name', '')}</p>
              <br />
              <h5>Upload Images</h5>
              <div className="row">
                <div className="col-md-4">
                  {!uploadProgress ?
                    <div className="dashed-border" onClick={() => document.getElementById('fileinput').click()}>
                    <input
                      type="file"
                      id="fileinput"
                      accept="image/png, image/jpeg"
                      style={{ display: 'none' }}
                      onClick={(evt) => this.handleEmptyImage(evt)}
                      onChange={(evt) => this.handleUserImage(evt)}
                    />
                    <h5 className="drag-box">
                        <br/>
                      <span className="Upload_txt">Upload</span>
                    </h5>
                  </div> :
                    <img className="image-loader" src="/img/loader2.svg"/>
                  }
                </div>
                <div className="col-md-8">
                  <Slider {...settings}>
                    {this.townImages(report)}
                  </Slider>
                </div>
              </div>
              <br />
              <br />
            </div>
            <Dialog
              actions={actions}
              modal={false}
              open={this.state.openFeaturedDilog}
              onRequestClose={this.handleClose}
            >
              Do you want to mark it as featured?
            </Dialog>
            <Dialog
              actions={actions2}
              modal={false}
              open={this.state.openRemoveDilog}
              onRequestClose={this.handleClose}
            >
              Do you want to remove the image?
            </Dialog>
            <Snackbar open={this.state.openSnackbar} message={this.state.message} autoHideDuration={2000} onRequestClose={this.handleRequestClose} />
          </div>
        </div>
      </section>
    )
  }
}

export default reduxForm({
  form: 'EditTownImages', // a unique identifier for this form
  destroyOnUnmount: true
})(EditTownImages)
